import type { CancelablePromise } from 'app/API/core/CancelablePromise';
import { AsrProxyAdminService } from 'app/API/services';
import type {
  AsrCreateTranscriptionRequest,
  AsrCreateTranscriptionResponse,
  AsrDefaultModelResponse,
  AsrFallbacksResponse,
  AsrHealthCheckResponse,
  AsrHealthResponse,
  AsrJobsResponse,
  AsrModelsResponse,
  AsrProviderOptionsResponse,
  AsrProviderLimitsResponse,
  AsrReloadResponse,
  AsrRetrieveTranscriptionResponse,
  AsrRetriesResponse,
  AsrSettingsResponse,
  AsrSetProviderOptionsResponse,
} from './types';

export class AsrProxyService {
  public static health(): CancelablePromise<AsrHealthResponse> {
    return AsrProxyAdminService.health();
  }

  public static models(): CancelablePromise<AsrModelsResponse> {
    return AsrProxyAdminService.models();
  }

  public static providerOptions(): CancelablePromise<AsrProviderOptionsResponse> {
    return AsrProxyAdminService.providerOptions();
  }

  public static providerLimits(): CancelablePromise<AsrProviderLimitsResponse> {
    return AsrProxyAdminService.providerLimits();
  }

  public static setProviderOptions(options: Record<string, unknown>): CancelablePromise<AsrSetProviderOptionsResponse> {
    return AsrProxyAdminService.setProviderOptions({ requestBody: { options } });
  }

  public static runHealthCheck(): CancelablePromise<AsrHealthCheckResponse> {
    return AsrProxyAdminService.healthCheck();
  }

  public static jobs(limit = 50, search?: string): CancelablePromise<AsrJobsResponse> {
    return AsrProxyAdminService.jobs({ limit, ...(search ? { search } : {}) });
  }

  public static reload(): CancelablePromise<AsrReloadResponse> {
    return AsrProxyAdminService.reload();
  }

  public static settings(): CancelablePromise<AsrSettingsResponse> {
    return AsrProxyAdminService.settings();
  }

  public static setDefaultModel(model: string): CancelablePromise<AsrDefaultModelResponse> {
    return AsrProxyAdminService.setDefaultModel({ requestBody: { model } });
  }

  public static setRetries(count: number, delayMs: number): CancelablePromise<AsrRetriesResponse> {
    return AsrProxyAdminService.setRetries({ requestBody: { count, delayMs } });
  }

  public static setFallbacks(models: string[]): CancelablePromise<AsrFallbacksResponse> {
    return AsrProxyAdminService.setFallbacks({ requestBody: { models } });
  }

  public static createTranscription(
    body: AsrCreateTranscriptionRequest,
  ): CancelablePromise<AsrCreateTranscriptionResponse> {
    return AsrProxyAdminService.createTranscription({ requestBody: body });
  }

  public static retrieveTranscription(id: string): CancelablePromise<AsrRetrieveTranscriptionResponse> {
    return AsrProxyAdminService.retrieveTranscription({ id });
  }
}
